import styled from 'styled-components';
import { Text } from '@appcues/sonar';

export const Action = styled(Text).attrs({
  size: 'small',
})``;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-x-small);
  font-size: var(--font-size-small);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${Action} {
    display: contents;
    color: var(--foreground-secondary);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
